module.exports = __webpack_public_path__ + "static/macrumors-d66630bebd37f753861218c6f1abea18.png";